import { Button, Col, Input, Row, Select } from "antd"
import { CSSProperties } from "react"
const styleModel: CSSProperties = {
  display: 'flex',
  justifyItems: 'center',
  alignItems: 'center'
}
interface SystemItemSearchViewProps {
  name?: string
  setName: (val: string) => void
  unit?: string
  setUnit: (val: string) => void

  phone?: string
  setPhone: (val: string) => void
  role?: string
  setRole: (val: string) => void
  type?: number
  setType: (val: number) => void
  clear: () => void
  searchLoading: boolean
  searchUsers: (page: number) => void
}

const SystemItemSearchView = (p: SystemItemSearchViewProps) => {
  const { name, setName } = p
  const { unit, setUnit } = p
  const { phone, setPhone } = p
  const { role, setRole } = p
  const { type, setType } = p
  const { clear, searchLoading, searchUsers } = p

  return (
    <div style={{ paddingBottom: '15px', paddingLeft: '15px', paddingRight: '15px' }}>
      <Row gutter={[30, 10]}>
        <Col span={8}>
          <div style={styleModel}>
            姓&emsp;&emsp;名：<Input style={{ flex: 1 }} placeholder="请输入" value={name} onChange={(e) => setName(e.target.value)} />
          </div>
        </Col>
        <Col span={8}>
          <div style={styleModel}>
            单&emsp;&emsp;位：<Input style={{ flex: 1 }} placeholder="请输入" value={unit} onChange={(e) => setUnit(e.target.value)} />
          </div>
        </Col>
        {/* <Col  span={8}>
          <div style={styleModel}>
              姓&emsp;&emsp;别：<Select
                          style={{flex:1}}
                          value={sex}
                          placeholder={'请选择'}
                          onChange={(value)=>setSex(value)}
                          options={[
                            { value: '男', label: '男' },
                            { value: '女', label: '女' },
                          ]}
                        />
            </div>
        </Col> */}
        <Col span={8}>
          <div style={styleModel}>
            电话号码：<Input style={{ flex: 1 }} placeholder="请输入" value={phone} onChange={(e) => setPhone(e.target.value)} />
          </div>
        </Col>
        <Col span={8}>
          <div style={styleModel}>
            角&emsp;&emsp;色：<Select
              style={{ flex: 1 }}
              value={role}
              placeholder={'请选择'}
              onChange={(value) => setRole(value)}
              options={[
                { value: 'admin', label: 'admin' },
                { value: 'super-admin', label: 'super-admin' },
              ]}
            />
          </div>
        </Col>

        <Col span={8}>
          <div style={styleModel}>
            状&emsp;&emsp;态：<Select
              style={{ flex: 1 }}
              value={type}
              placeholder={'请选择'}
              onChange={(value) => setType(value)}
              options={[
                { value: 1, label: '正常' },
                { value: 2, label: '废弃' },
              ]}
            />
          </div>
        </Col>
        <Col span={8}>
          <div style={{ display: 'flex', justifyContent: 'flex-end', justifyItems: 'flex-end' }}>
            <Button type="primary" onClick={() => {
              clear()
            }}>重置</Button>
            <Button type="primary" style={{ marginLeft: '10px' }} loading={searchLoading} onClick={() => searchUsers(1)}>
              查询
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export type { }
export default SystemItemSearchView